/**
 * Ensec Translator — Hård-kodad SV → EN översättning
 *
 * Funkar genom att gå igenom DOM:en och översätta text noder.
 * Lyssnar på MutationObserver så att framtida content (AJAX, nya
 * produkter, nya sektioner) också översätts automatiskt.
 *
 * Aktiveras av language-switcher (data-ensec-lang-btn="en")
 * och persisteras i localStorage.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ensecLang';
  var DEFAULT_LANG = 'sv';

  var shopifyLangs = parseInt(document.documentElement.dataset.shopifyLangs || '1', 10);
  var shopifyLocale = (document.documentElement.dataset.shopifyLocale || 'sv').toLowerCase();
  var SHOPIFY_MULTILANG = shopifyLangs > 1;

  if (SHOPIFY_MULTILANG) {
    document.documentElement.dataset.ensecLang = shopifyLocale;
    try { localStorage.setItem(STORAGE_KEY, shopifyLocale); } catch (e) {}
  }

  var DICT = { 'Pris på förfrågan': 'Price on request', 'Vi återkommer med pris och leveranstid.': 'We will get back to you with price and delivery time.', 'Kategori': 'Category', 'över 1 500 kr': 'over SEK 1,500', 'över': 'over',
    'Säkerhet för hem & företag.': 'Security for home & business.',
    'Säkerhet för hem & företag': 'Security for home & business',
    'Hela sortimentet.': 'Full range.',
    'På ett ställe.': 'In one place.',
    'Säkerhetslösningar uppdelade efter vad du vill skydda.':
      'Security solutions sorted by what you want to protect.',
    'Hjälp mig välja.': 'Help me choose.',
    'Konkret. Snabbt.': 'Concrete. Fast.',
    'Diskret skydd.': 'Discreet protection.',
    'När det räknas mest.': 'When it matters most.',
    'Vi gör jobbet åt dig': 'We do the work for you',
    'Utforska produkter': 'Explore products',
    'Fyra lager säkerhet — i ett system': 'Four layers of security — in one system',
    'Färdiga krispaket': 'Ready crisis kits',
    'Sex säkerhetsområden': 'Six security areas',
    'Shoppa efter användning': 'Shop by use case',
    'Hittar du inte rätt?': 'Can’t find what you need?',
    'Fortfarande osäker?': 'Still unsure?',
    'Vad skyddar du?': 'What are you protecting?',
    'Hur teknikvan är du?': 'How tech-savvy are you?',
    'Vilken budget?': 'What budget?',
    'Varför hos oss?': 'Why with us?',
    'Till butiken': 'To shop',
    'TILL BUTIKEN': 'TO SHOP',
    'B2B Portal': 'B2B Portal',
    'B2B PORTAL': 'B2B PORTAL',
    'Shoppa nu': 'Shop now',
    'SHOPPA NU': 'SHOP NOW',
    'Shoppa nu →': 'Shop now →',
    'Shoppa direkt': 'Shop now',
    'Läs guiden': 'Read the guide',
    'LÄS GUIDEN': 'READ THE GUIDE',
    'Öppna AI-guiden': 'Open AI guide',
    'Starta AI-guiden': 'Start AI guide',
    'STARTA AI-GUIDEN': 'START AI GUIDE',
    '5-MIN GUIDE': '5-MIN GUIDE',
    '🧭 5-min guide': '🧭 5-min guide',
    'Se alla erbjudanden': 'See all offers',
    'Se alla kit': 'See all kits',
    'Tillbaka': 'Back',
    'TILLBAKA': 'BACK',
    'Lägg i varukorgen': 'Add to cart',
    'LÄGG I VARUKORGEN': 'ADD TO CART',
    'Köp': 'Buy',
    'Köp nu': 'Buy now',
    'Skicka förfrågan': 'Send inquiry',
    'SKICKA FÖRFRÅGAN': 'SEND INQUIRY',
    'Boka rådgivning': 'Book consultation',
    'Boka installation': 'Book installation',
    'Begär hybrid-paket': 'Request hybrid package',
    'Begär Standard-offert': 'Request Standard quote',
    'Begär offert': 'Request quote',
    'BEGÄR OFFERT': 'REQUEST QUOTE',
    'Boka konfidentiell konsultation': 'Book confidential consultation',
    'BOKA KONFIDENTIELL KONSULTATION': 'BOOK CONFIDENTIAL CONSULTATION',
    'Boka kostnadsfri konsultation': 'Book free consultation',
    'Utforska butiken': 'Explore the shop',
    'Utforska hela butiken': 'Explore the full shop',
    'Se Starter-utbud': 'See Starter range',
    'KATEGORIER': 'CATEGORIES',
    'Alla produkter': 'All products',
    'Cybersäkerhet': 'Cybersecurity',
    'Kameror & hemlarm': 'Cameras & home alarm',
    'Kameror': 'Cameras',
    'Hemlarm': 'Home alarm',
    'Kommunikation': 'Communication',
    'Kryptering': 'Encryption',
    'Signalblockering': 'Signal blocking',
    'Erbjudande': 'Offers',
    'Bästsäljare': 'Best sellers',
    'I lager': 'In stock',
    'Slut i lager': 'Out of stock',
    'produkter': 'products',
    'PRODUKTER': 'PRODUCTS',
    'Från': 'From',
    'Kommer snart': 'Coming soon',
    'COMING SOON': 'COMING SOON',
    'Specifikationer': 'Specifications',
    'Beskrivning': 'Description',
    'Underrubrik': 'Subtitle',
    'Rubrik': 'Title',
    'skickas idag om du beställer': 'ships today if you order',
    'skickas idag om du beställer innan 14:00':
      'ships today if you order before 14:00',
    'innan 14:00': 'before 14:00',
    'Fri frakt över 1 500 kr': 'Free shipping over 1 500 kr',
    'Fri frakt': 'Free shipping',
    '2–7 arbetsdagar': '2–7 business days',
    '2-7 arbetsdagar': '2-7 business days',
    '2 års garanti': '2-year guarantee',
    'På all utrustning': 'On all equipment',
    '20+ års erfarenhet': '20 years of experience',
    'Erfarenhet och expertis': 'Experience and expertise',
    'Installation & support': 'Installation & support',
    'Från 1 495 kr': 'From 1 495 kr',
    '30 dagars öppet köp': '30-day return policy',
    'Säkra betalningar': 'Secure payments',
    'Kontakta oss': 'Contact us',
    'KONTAKTA OSS': 'CONTACT US',
    'Kontakta oss →': 'Contact us →',
    'PRIVATPERSON': 'INDIVIDUAL',
    'Privatperson': 'Individual',
    'FÖRETAG': 'BUSINESS',
    'Företag': 'Business',
    'Förnamn': 'First name',
    'FÖRNAMN': 'FIRST NAME',
    'Efternamn': 'Last name',
    'EFTERNAMN': 'LAST NAME',
    'E-post': 'Email',
    'E-POST': 'EMAIL',
    'Telefon': 'Phone',
    'TELEFON': 'PHONE',
    'Företagsnamn': 'Company name',
    'FÖRETAGSNAMN': 'COMPANY NAME',
    'Organisationsnummer': 'Organization number',
    'ORGANISATIONSNUMMER': 'ORGANIZATION NUMBER',
    'Vad gäller ditt ärende?': 'What is your inquiry about?',
    'VAD GÄLLER DITT ÄRENDE?': 'WHAT IS YOUR INQUIRY ABOUT?',
    'Välj ett alternativ…': 'Select an option…',
    'Meddelande': 'Message',
    'MEDDELANDE': 'MESSAGE',
    'Berätta kort vad du behöver hjälp med — så återkommer vi med rätt person.':
      'Briefly describe what you need help with — we’ll get back with the right person.',
    'Produktinformation': 'Product information',
    'Installation eller offert': 'Installation or quote',
    'Planering & konsultation': 'Planning & consultation',
    'Befintlig kund / support': 'Existing customer / support',
    'Ansökan om B2B-konto': 'B2B account application',
    'PBS — Privata bevakningsvakter': 'PBS — Private bodyguards',
    'Boka showroom-besök': 'Book showroom visit',
    'Övrigt': 'Other',
    'Filter and sort': 'Filter and sort',
    'FILTER AND SORT': 'FILTER AND SORT',
    'Filter och sortering': 'Filter and sort',
    'SORT BY': 'SORT BY',
    'Sortera efter': 'Sort by',
    'FILTER:': 'FILTER:',
    'Filter': 'Filter',
    'Rensa filter': 'Clear filter',
    'Pris': 'Price',
    'PRIS': 'PRICE',
    'Tillgänglighet': 'Availability',
    'TILLGÄNGLIGHET': 'AVAILABILITY',
    'AVAILABILITY': 'AVAILABILITY',
    'Märke': 'Brand',
    'MÄRKE': 'BRAND',
    'Säkerhetsteknik från svensk leverantör — för hem och företag.':
      'Security technology from a Swedish supplier — for home and business.',
    'LANGUAGE': 'LANGUAGE',
    'Kontakt': 'Contact',
    'KONTAKT': 'CONTACT',
    'Meny': 'Menu',
    'MENY': 'MENU',
    'Butik': 'Shop',
    'BUTIK': 'SHOP',
    'Butik – guide': 'Shop – guide',
    'PBS — Bodyguard': 'PBS — Bodyguard',
    'Få 10 % rabatt': 'Get 10% off',
    'Få 10 % rabatt på första köpet': 'Get 10% off your first purchase',
    'Anmäl dig till nyhetsbrevet': 'Sign up for our newsletter',
    'Privacy policy': 'Privacy policy',
    'Cookie preferences': 'Cookie preferences',
    'Integritetspolicy': 'Privacy policy',
    'Allmänna villkor': 'Terms of service',
    'Frakt & retur': 'Shipping & returns',
    'Återbetalning': 'Refund policy',
    'FÖRETAGSKÖP': 'BUSINESS PURCHASE',
    'Företagsköp': 'Business purchase',
    'Från 5 st — företagspris': 'From 5 units — business price',
    '24/7': '24/7',
    'RING DIREKT': 'CALL DIRECTLY',
    'Ring direkt': 'Call directly',
    'SÄKER E-POST': 'SECURE EMAIL',
    'Säker e-post': 'Secure email',
    'KÄLLA — PARTNER': 'SOURCE — PARTNER',
    'PBS — PRIVATE BODYGUARD SERVICE': 'PBS — PRIVATE BODYGUARD SERVICE',
    'SÄKERHETSGUIDE · 4 FRÅGOR': 'SECURITY GUIDE · 4 QUESTIONS',
    'BUTIK · HELA SORTIMENTET': 'SHOP · FULL RANGE',
    '5 MIN · AI-DRIVEN HJÄLP': '5 MIN · AI-DRIVEN HELP',
    'Beredskap': 'Readiness',
    'BEREDSKAP': 'READINESS',
    'Diskretion': 'Discretion',
    'DISKRETION': 'DISCRETION',
    'Räckvidd': 'Reach',
    'RÄCKVIDD': 'REACH',
    'år erfarenhet': 'years of experience',
    'ÅR ERFARENHET': 'YEARS OF EXPERIENCE',
    'genomförda uppdrag': 'completed missions',
    'GENOMFÖRDA UPPDRAG': 'COMPLETED MISSIONS',
    'incidenter under uppdrag': 'incidents during missions',
    'INCIDENTER UNDER UPPDRAG': 'INCIDENTS DURING MISSIONS',
    'Diskret närvaro': 'Discreet presence',
    'Aktivt skydd': 'Active protection',
    'Fullt skyddsteam': 'Full protection team',
    'NIVÅER': 'LEVELS',
    'NIVÅ 1': 'LEVEL 1',
    'NIVÅ 2': 'LEVEL 2',
    'NIVÅ 3': 'LEVEL 3',
    'VANLIGAST': 'MOST COMMON',
    'KONSULTATION': 'CONSULTATION',
    'Diskret samtal': 'Discreet conversation',
    'Tre skyddsnivåer': 'Three levels of protection',
    'Komplett skydd': 'Complete protection',
    'Privat utredning': 'Private investigation',
    'Utbildning': 'Education',
    'Utbildningar': 'Trainings',
    'UTBILDNING': 'EDUCATION',
    'VÅRA TJÄNSTER': 'OUR SERVICES',
    'VÅRA PRODUKTOMRÅDEN': 'OUR PRODUCT AREAS',
    'VÅRT TEAM': 'OUR TEAM',
    'SHOPPA EFTER KATEGORI': 'SHOP BY CATEGORY',
    'AKTUELLA ERBJUDANDEN': 'CURRENT OFFERS',
    'KRIS & BEREDSKAP KIT': 'CRISIS & READINESS KIT',
    'VAD VILL DU SKYDDA?': 'WHAT DO YOU WANT TO PROTECT?',
    'DIREKTVÄGAR': 'SHORTCUTS',
    'PARTNERS': 'PARTNERS',
    'OSÄKER PÅ VAD DU BEHÖVER?': 'UNSURE WHAT YOU NEED?',
    'BLI PARTNER': 'BECOME A PARTNER',
    'Ansök': 'Apply',
    'ANSÖK': 'APPLY',
    'B2B PORTAL · ENSEC': 'B2B PORTAL · ENSEC',
    'Återförsäljare': 'Resellers',
    'Installatörer': 'Installers',
    'Storkund': 'Key accounts',
    'Företagspriser direkt': 'Business prices instantly',
    'Exklusiva varumärken': 'Exclusive brands',
    'Dedikerad kontaktperson': 'Dedicated contact',
    'Offert & volymrabatt': 'Quote & volume discount',
    'Showroom & demo': 'Showroom & demo',
    'Snabb leverans': 'Fast delivery',
    'Logga in': 'Log in',
    'LOGGA IN': 'LOG IN',
    'och': 'and',
    'eller': 'or',
    'inkl.': 'incl.',
    'st': 'pcs',
    'mån': 'mo',
    'år': 'years',
    'tim': 'hr',
    'min': 'min',
    'mån.': 'mo.',
    'månader': 'months',
    'dagar': 'days',
    'med': 'with',
    'utan': 'without',
    'hem': 'home',
    'företag': 'business',
    'kontor': 'office',
    'Hem': 'Home',
    'Företag': 'Business',
    'Hem &amp; företag': 'Home & business',
    'hem &amp; företag': 'home & business',
    'hem & företag': 'home & business',
    'från': 'from',
    'till': 'to',
    'mer': 'more',
    'mindre': 'less',
    'fler': 'more',
    'färre': 'fewer',
    'Sök': 'Search',
    'SÖK': 'SEARCH',
    'Sök produkter': 'Search products',
    'Sök produkter…': 'Search products…',
    'Sök på sidan': 'Search the site',
    'Sökresultat': 'Search results',
    'Inga resultat': 'No results',
    'Hittar du inte rätt? Kontakta oss så hjälper vi dig.': 'Can’t find what you need? Contact us and we’ll help you.',
    'Hittar du fortfarande inte rätt?': 'Still can’t find what you need?',
    'så hjälper vi dig.': 'and we’ll help you.',
    'Visa fler': 'Show more',
    'Visa mer': 'Show more',
    'Visa färre': 'Show fewer',
    'Ladda fler': 'Load more',
    'Föregående': 'Previous',
    'Nästa': 'Next',
    'Föregående sida': 'Previous page',
    'Nästa sida': 'Next page',
    'Mitt konto': 'My account',
    'Logga ut': 'Log out',
    'Mitt hem': 'My home',
    'Mitt företag': 'My business',
    'Min telefon & data': 'My phone & data',
    'Mina samtal': 'My calls',
    'Mig själv (hot)': 'Myself (threat)',
    'Strömavbrott': 'Power outage',
    'Varukorg': 'Cart',
    'VARUKORG': 'CART',
    'Din varukorg': 'Your cart',
    'Din varukorg är tom': 'Your cart is empty',
    'Antal': 'Quantity',
    'Quantity': 'Quantity',
    'Summa': 'Subtotal',
    'Totalt': 'Total',
    'Inkl. moms': 'VAT included',
    'Taxes included.': 'Taxes included.',
    'Frakt beräknas i kassan': 'Shipping calculated at checkout',
    'Till kassan': 'Checkout',
    'TILL KASSAN': 'CHECKOUT',
    'Fortsätt handla': 'Continue shopping',
    'Ta bort': 'Remove',
    'Spara': 'Save',
    'Uppdatera': 'Update',
    'Öka antal': 'Increase quantity',
    'Minska antal': 'Decrease quantity',
    'Lägg till': 'Add',
    'Lägg till i varukorgen': 'Add to cart',
    'Tillagd i varukorgen': 'Added to cart',
    'Visa varukorg': 'View cart',
    'Snabb-add': 'Quick add',
    'View cart': 'View cart',
    'Behöver du installationshjälp?': 'Need installation help?',
    'Boka kostnadsfri konsultation →': 'Book free consultation →',
    'Eller': 'Or',
    'i 12 månader med Klarna. 0 % ränta.': 'in 12 months with Klarna. 0% interest.',
    '0 % ränta': '0% interest',
    'I varukorg': 'In cart',
    'Lägg i varukorg': 'Add to cart',
    'Köpe nu med': 'Buy now with',
    'Fler betalningsalternativ': 'More payment options',
    'Beställ via samtal': 'Order by phone',
    'Kontakta för pris': 'Contact for price',
    'Specifikation': 'Specification',
    'Manual': 'Manual',
    'Manual (PDF)': 'Manual (PDF)',
    'Datablad': 'Datasheet',
    'Innehåll i förpackningen': 'In the box',
    'Kompatibilitet': 'Compatibility',
    'Relaterade produkter': 'Related products',
    'Du kanske också gillar': 'You may also like',
    'Senast besökta': 'Recently viewed',
    'Recensioner': 'Reviews',
    'Skriv en recension': 'Write a review',
    'Stjärnor': 'Stars',
    'av': 'of',
    'recension': 'review',
    'recensioner': 'reviews',
    'kunder köpte också': 'customers also bought',
    'Kunder köpte också': 'Customers also bought',
    'Lager': 'Stock',
    'Få kvar': 'Few left',
    'Endast': 'Only',
    'kvar': 'left',
    'Products': 'Products',
    'Produkter': 'Products',
    'Inga produkter hittades': 'No products found',
    'Tillämpa filter': 'Apply filter',
    'Sortera': 'Sort',
    'Visar': 'Showing',
    'Visar alla': 'Showing all',
    'Filtrera': 'Filter',
    'Alfabetiskt, A-Ö': 'Alphabetically, A-Z',
    'Alfabetiskt, Ö-A': 'Alphabetically, Z-A',
    'Pris, lågt till högt': 'Price, low to high',
    'Pris, högt till lågt': 'Price, high to low',
    'Datum, nytt till gammalt': 'Date, new to old',
    'Datum, gammalt till nytt': 'Date, old to new',
    'Bästsäljare': 'Best selling',
    'Manuellt': 'Manually',
    'Relevans': 'Relevance',
    'Alphabetically, A-Z': 'Alphabetically, A-Z',
    'Hela sortimentet': 'Full range',
    'På ett ställe': 'In one place',
    'Säkerhetslösningar uppdelade efter vad du vill skydda': 'Security solutions sorted by what you want to protect',
    'OFF-grid': 'OFF-grid',
    'OFF-GRID': 'OFF-GRID',
    'TSCM': 'TSCM',
    'Faraday': 'Faraday',
    'DPN': 'DPN',
    'AI-DRIVEN HJÄLP': 'AI-DRIVEN HELP',
    'Bli partner': 'Become a partner',
    'Vi granskar din ansökan inom 1-2 arbetsdagar.': 'We review your application within 1-2 business days.',
    'Vi granskar din ansökan inom 1–2 arbetsdagar.': 'We review your application within 1–2 business days.',
    'Svar via e-post.': 'Reply via email.',
    'Vi granskar din ansökan inom 1-2 arbetsdagar. Svar via e-post.':
      'We review your application within 1-2 business days. Reply via email.',
    'Vi granskar din ansökan inom 1–2 arbetsdagar. Svar via e-post.':
      'We review your application within 1–2 business days. Reply via email.',
    'Hela ekosystemet': 'The whole ecosystem',
    'Godkända B2B-partners får ramavtalspriser från:': 'Approved B2B partners get framework agreement prices from:',
    'Företagskunder': 'Business customers',
    'Företagskunder direkt': 'Business customers instantly',
    'företagskunder': 'business customers',
    'år branscherfarenhet': 'years industry experience',
    'svensk support': 'Swedish support',
    'SVENSK SUPPORT': 'SWEDISH SUPPORT',
    'certifierad utrustning': 'certified equipment',
    'CERTIFIERAD UTRUSTNING': 'CERTIFIED EQUIPMENT',
    'För vilka': 'For whom',
    'FÖR VILKA': 'FOR WHOM',
    'Fem partner-typer': 'Five partner types',
    'Storkunder': 'Key accounts',
    'Säkerhetsföretag': 'Security companies',
    'Projektledare': 'Project managers',
    'Vad du får': 'What you get',
    'VAD DU FÅR': 'WHAT YOU GET',
    'Hur det fungerar': 'How it works',
    'HUR DET FUNGERAR': 'HOW IT WORKS',
    'Fyra steg från första samtal till aktiv skydd': 'Four steps from first call to active protection',
    'TYPSITUATIONER': 'TYPICAL SITUATIONS',
    'Vi tar uppdrag inom dessa områden': 'We take assignments in these areas',
    'Vi skyddar': 'We protect',
    'Ledare & VD': 'Leaders & CEO',
    'Offentliga personer': 'Public figures',
    'Stalker-skydd': 'Stalker protection',
    'Familjer': 'Families',
    'Evenemang': 'Events',
    'Resa & transport': 'Travel & transport',
    'HBTQ-skydd': 'LGBTQ protection',
    'Nattlivsskydd': 'Nightlife protection',
    'Konfidentiell kontakt': 'Confidential contact',
    'Hotbedömning': 'Threat assessment',
    'Skyddsplan & offert': 'Protection plan & quote',
    'PLUG & PLAY': 'PLUG & PLAY',
    'HYBRID': 'HYBRID',
    'DIY': 'DIY',
    'STARTER': 'STARTER',
    'STANDARD': 'STANDARD',
    'PREMIUM': 'PREMIUM',
    'REKOMMENDERAS': 'RECOMMENDED',
    'Tre starter-paket beroende på vad du vill skydda.':
      'Three starter packages depending on what you want to protect.',
    'Tre starter-paket beroende på vad du vill skydda':
      'Three starter packages depending on what you want to protect',
    'Källa — partner': 'Source — partner',
    'Få 10 % rabatt på första köpet.': 'Get 10% off your first purchase.',
    'Anmäl dig till nyhetsbrevet och få rabattkoden direkt i inkorgen.':
      'Sign up for our newsletter and get the discount code directly in your inbox.',
    'Anmäl': 'Sign up',
    'Din e-post': 'Your email',
    'din e-post': 'your email',
    'Prenumerera': 'Subscribe',
    'För dig': 'For you',
    'Privat': 'Private',
    'Företagskund': 'Business customer',
    'Login': 'Login',
    'Logga in på B2B-portal': 'Log in to B2B portal',
    'VM-kit': 'WC kit',
    'VM-KIT': 'WC KIT',
    'Sidan hittades inte': 'Page not found',
    'Sidan du letar efter finns inte.': 'The page you’re looking for doesn’t exist.',
    'Gå till startsidan': 'Go to homepage',
    'Ja': 'Yes',
    'Nej': 'No',
    'OK': 'OK',
    'Avbryt': 'Cancel',
    'Stäng': 'Close',
    'Stäng meny': 'Close menu',
    'Öppna meny': 'Open menu',
    'sidor': 'pages',
    'sida': 'page',
    'vald': 'selected',
    'valda': 'selected',
    'Visa lösenord': 'Show password',
    'Dölj lösenord': 'Hide password',
    'Lösenord': 'Password',
    'Glömt lösenord?': 'Forgot password?',
    'Skapa konto': 'Create account',
    'Logga in i ditt konto': 'Log in to your account',
    'NYHETER': 'NEWS',
    'NYHET': 'NEW',
    'NEDSATT': 'SALE',
    'REA': 'SALE',
    'FÖRBESTÄLLNING': 'PRE-ORDER',
    'Reservera': 'Reserve',
    'inom 14:00': 'before 14:00',
    'innan': 'before',
    'efter': 'after',
    'CE & SSF-certifierad utrustning': 'CE & SSF-certified equipment',
    'Svensk support under ordinarie öppettider': 'Swedish support during business hours',
    'Klarna. Delbetalning från 0 %': 'Klarna. Pay later from 0 %',
    'Klarna. Delbetalning från 0%': 'Klarna. Pay later from 0%',
    '20+ år erfarenhet': '20+ years experience',
    '20+ års erfarenhet': '20+ years experience',
    '100+ installationer': '100+ installations',
    '1000+ installationer': '100+ installations',
    '9 premium-partners': '9 premium partners',
    'Förlängd upp till 5 år': 'Extended up to 5 years',
    'Ordinarie öppettider': 'Business hours',
    'SLA-baserad support under ordinarie öppettider': 'SLA-based support during business hours',
    'Support under ordinarie öppettider ingår alltid.': 'Support during business hours is always included.',
    'Förlängd garanti upp till 5 år finns tillgänglig.': 'Extended guarantee of up to 5 years is available.',
    'NYHETSBREV': 'NEWSLETTER',
    'Nyhetsbrev': 'Newsletter',
    'FÅ 10 % RABATT': 'GET 10 % OFF',
    'FÅ 10% RABATT': 'GET 10% OFF',
    'SKICKA': 'SUBMIT',
    'Skicka': 'Submit',
    'Anmäl dig så får du 10 % rabatt + säkerhetsguider direkt i inkorgen.':
      'Sign up and get 10 % off + security guides directly to your inbox.',
    'Anmäl dig så får du 10% rabatt + säkerhetsguider direkt i inkorgen.':
      'Sign up and get 10% off + security guides directly to your inbox.',
    'Tack — du är prenumerant!': 'Thanks — you are subscribed!',
    'Tack - du är prenumerant!': 'Thanks - you are subscribed!',
    'Använd koden i kassan för att få rabatt:': 'Use the code at checkout to get your discount:',
    'Den e-posten är redan registrerad hos oss.': 'That email is already registered with us.',
    'OK, fortsätt': 'OK, continue',
    'Följ oss': 'Follow us',
    'FÖLJ OSS': 'FOLLOW US',
    'Betalsätt': 'Payment methods',
    'BETALSÄTT': 'PAYMENT METHODS',
    'Vi levererar till': 'We ship to',
    'VI LEVERERAR TILL': 'WE SHIP TO',
    'Frakt & leverans': 'Shipping & delivery',
    'Återbetalningspolicy': 'Refund policy',
    'Om Ensec': 'About Ensec',
    'OM ENSEC': 'ABOUT ENSEC',
    'support 24/7': 'support 24/7',
    'Säkerhetsteknik från svensk leverantör': 'Security tech from a Swedish supplier',
    'Säkerhetsteknik från en svensk leverantör': 'Security tech from a Swedish supplier',
    'Behöver du hjälp?': 'Need help?',
    'Boka en kostnadsfri konsultation': 'Book a free consultation',
    '30 dagars öppet köp': '30-day returns',
    'Klarna delbetalning': 'Klarna partial payments',
    'Public Broadcapcsing Service': 'PBS',
    'PUBLIC BROADCAPCSING SERVICE': 'PBS',
    'OUR PRODUCT ASALES': 'OUR PRODUCT AREAS',
    'OUR PRODUCT AREAS': 'OUR PRODUCT AREAS',
    'Our product asales': 'Our product areas',
    'Camoreas & Home Alarms': 'Cameras & Home Alarms',
    'Safety equipment from the indupcsry’s mopcs recognized brands — for home and business.':
      'Security equipment from the industry’s most recognized brands — for home and business.',
    'Safety equipment from the industry’s most recognized brands — for home and business.':
      'Security equipment from the industry’s most recognized brands — for home and business.',
    'Våra produktområden': 'Our product areas',
    'VÅRA PRODUKTOMRÅDEN': 'OUR PRODUCT AREAS',
    'Säkerhetsutrustning från industrins mest erkända varumärken — för hem och företag.':
      'Security equipment from the industry’s most recognized brands — for home and business.',
    'Säkerhetsutrustning från industrins mest erkända varumärken':
      'Security equipment from the industry’s most recognized brands',
    'Kameror & hemlarm': 'Cameras & alarm systems',
    'KAMEROR & HEMLARM': 'CAMERAS & ALARM SYSTEMS',
    'Cameras & home alarms': 'Cameras & alarm systems',
    'Camoreas & home alarms': 'Cameras & alarm systems',
    'CAMERAS & HOME ALARMS': 'CAMERAS & ALARM SYSTEMS',
    'Camoreas & alarm sypcsems': 'Cameras & alarm systems',
    'Camoreas & alarm systems': 'Cameras & alarm systems',
    'Cameras & alarm sypcsems': 'Cameras & alarm systems',
    'alarm sypcsems': 'alarm systems',
    'Alarm sypcsems': 'Alarm systems',
    'ALARM SYPCSEMS': 'ALARM SYSTEMS',
    'sypcsems': 'systems',
    'Sypcsems': 'Systems',
    'Camoreas': 'Cameras',
    'camoreas': 'cameras',
    'CAMOREAS': 'CAMERAS',
    'indupcsry': 'industry',
    'Indupcsry': 'Industry',
    'INDUPCSRY': 'INDUSTRY',
    'mopcs': 'most',
    'Mopcs': 'Most',
    'MOPCS': 'MOST',
    'asales': 'areas',
    'Asales': 'Areas',
    'ASALES': 'AREAS',
    'inpcsall': 'install',
    'Inpcsall': 'Install',
    'INPCSALL': 'INSTALL',
    'inpcsallation': 'installation',
    'Inpcsallation': 'Installation',
    'Alarms, camoreas and security technology. We deliver, inpcsall, and support — so you can feel safe around the clock.':
      'Alarms, cameras and security technology. We deliver, install, and support — so you can feel safe around the clock.',
    'Alarms, camoreas and security technology':
      'Alarms, cameras and security technology',
    'We deliver, inpcsall, and support':
      'We deliver, install, and support'
  };

  function getLang() {
    if (SHOPIFY_MULTILANG) {
      return shopifyLocale === 'en' ? 'en' : 'sv';
    }
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'en' || saved === 'sv') return saved;
    } catch (e) {}
    return DEFAULT_LANG;
  }

  function setLang(lang) {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
    document.documentElement.dataset.ensecLang = lang;
  }

  var SORTED_KEYS = Object.keys(DICT).sort(function (a, b) {
    return b.length - a.length;
  });

  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  var MASTER_REGEX = new RegExp(
    '(' + SORTED_KEYS.map(escapeRegex).join('|') + ')(?![0-9A-Za-z\\u00C0-\\u024F])',
    'g'
  );

  var ACRONYM_OVEREXPANSIONS = [
    { long: 'Technical Surveillance Counter-Measures', short: 'TSCM' },
    { long: 'Public Broadcasting Service', short: 'PBS' }
  ];

  function buildAcronymRegex(pair, variant) {
    var longForm =
      variant === 'lower' ? pair.long.toLowerCase() :
      variant === 'upper' ? pair.long.toUpperCase() :
      pair.long;
    return new RegExp(
      '(?<!' + escapeRegex(pair.short) + ' \\()' + escapeRegex(longForm),
      'g'
    );
  }

  function collapseAcronymOverExpansions(text) {
    if (!text || typeof text !== 'string') return text;
    ACRONYM_OVEREXPANSIONS.forEach(function (pair) {
      ['as-is', 'lower', 'upper'].forEach(function (variant) {
        text = text.replace(buildAcronymRegex(pair, variant), pair.short);
      });
    });
    return text;
  }

  function translateText(text) {
    if (!text || typeof text !== 'string') return text;

    var trimmed = text.trim();
    if (trimmed && DICT[trimmed]) {
      var leading = text.match(/^\s*/)[0];
      var trailing = text.match(/\s*$/)[0];
      return leading + collapseAcronymOverExpansions(DICT[trimmed]) + trailing;
    }

    var replaced = text.replace(MASTER_REGEX, function (match, p1, offset, whole) {
      if (offset > 0 && /[0-9A-Za-zÀ-ɏ]/.test(whole.charAt(offset - 1)) && /[0-9A-Za-zÀ-ɏ]/.test(match.charAt(0))) return match; return DICT[match] || match;
    });
    return collapseAcronymOverExpansions(replaced);
  }

  function saveOriginal(node) {
    if (node._ensecOriginal === undefined) {
      node._ensecOriginal = node.textContent;
    }
  }

  function translateNode(node, lang) {
    if (!node) return;
    if (node.nodeType === Node.ELEMENT_NODE) {
      var tag = node.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'CODE' || tag === 'NOSCRIPT') return;
      if (node.dataset && node.dataset.noTranslate !== undefined) return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      var raw = node.textContent;
      if (!raw || !/\S/.test(raw)) return;
      if (!/[a-zåäöA-ZÅÄÖ]/.test(raw)) return;

      saveOriginal(node);
      var source = node._ensecOriginal;
      node.textContent = (lang === 'en') ? translateText(source) : source;
      return;
    }

    var children = node.childNodes;
    for (var i = 0; i < children.length; i++) {
      translateNode(children[i], lang);
    }
  }

  var ATTRS_TO_TRANSLATE = ['placeholder', 'aria-label', 'title', 'alt'];

  function translateAttributes(root, lang) {
    root = root || document.body;
    ATTRS_TO_TRANSLATE.forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        if (el.dataset.noTranslate !== undefined) return;
        var savedKey = '_ensecOriginal_' + attr;
        if (el[savedKey] === undefined) {
          el[savedKey] = el.getAttribute(attr);
        }
        var source = el[savedKey];
        if (!source) return;
        el.setAttribute(attr, (lang === 'en') ? translateText(source) : source);
      });
    });
  }

  var FLAGS = {
    sv: '<svg viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">' +
        '<rect width="20" height="14" fill="#006AA7"/>' +
        '<rect x="6" width="2.5" height="14" fill="#FECC00"/>' +
        '<rect y="5.75" width="20" height="2.5" fill="#FECC00"/>' +
        '</svg>',
    en: '<svg viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">' +
        '<rect width="20" height="14" fill="#012169"/>' +
        '<path d="M0,0 L20,14 M20,0 L0,14" stroke="#FFF" stroke-width="2.4"/>' +
        '<path d="M0,0 L20,14 M20,0 L0,14" stroke="#C8102E" stroke-width="1"/>' +
        '<rect x="8.25" width="3.5" height="14" fill="#FFF"/>' +
        '<rect y="5.25" width="20" height="3.5" fill="#FFF"/>' +
        '<rect x="9" width="2" height="14" fill="#C8102E"/>' +
        '<rect y="6" width="20" height="2" fill="#C8102E"/>' +
        '</svg>'
  };

  function updateLangTriggers(lang) {
    var code = lang.toUpperCase();
    var flag = FLAGS[lang] || FLAGS.sv;

    document.documentElement.setAttribute('data-ensec-active-lang', lang);

    var triggers = document.querySelectorAll(
      '.ensec-lang__button, .ensec-lang__button--static'
    );

    triggers.forEach(function (trigger) {
      trigger.setAttribute('data-current-lang', lang);

      var flagEl = trigger.querySelector('.ensec-lang__flag');
      if (flagEl) {
        flagEl.innerHTML = '';
        flagEl.insertAdjacentHTML('afterbegin', flag);
      }

      var codeEl = trigger.querySelector('.ensec-lang__code');
      if (codeEl) codeEl.textContent = code;

      var ariaLabel = trigger.getAttribute('aria-label');
      if (ariaLabel) {
        trigger.setAttribute('aria-label', 'Språk: ' + code);
      }
    });

    document.querySelectorAll('.ensec-lang__link').forEach(function (link) {
      var linkLang = (link.getAttribute('hreflang') || link.getAttribute('lang') || link.dataset.ensecLangBtn || '').toLowerCase();
      var isActive = linkLang === lang;
      link.classList.toggle('ensec-lang__link--active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
      var existingCheck = link.querySelector('.ensec-lang__check');
      if (isActive && !existingCheck) {
        var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkSvg.setAttribute('class', 'ensec-lang__check');
        checkSvg.setAttribute('width', '14');
        checkSvg.setAttribute('height', '14');
        checkSvg.setAttribute('viewBox', '0 0 14 14');
        checkSvg.setAttribute('fill', 'none');
        checkSvg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M3 7l3 3 5-6');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '2');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        checkSvg.appendChild(path);
        link.appendChild(checkSvg);
      } else if (!isActive && existingCheck) {
        existingCheck.remove();
      }
    });
  }

  var NO_TRANSLATE_PAGES = ['/pages/b2b', '/pages/pbs'];
  function isNoTranslatePage() {
    var path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    return NO_TRANSLATE_PAGES.some(function (p) {
      return path === p || path.indexOf(p + '/') === 0;
    });
  }

  function applyLang(lang) {
    setLang(lang);

    if (!isNoTranslatePage()) {
      translateNode(document.body, lang);
      translateAttributes(document.body, lang);
    }

    document.documentElement.lang = lang;
    updateLangTriggers(lang);
    document.querySelectorAll('[data-ensec-lang-btn]').forEach(function (btn) {
      btn.classList.toggle('ensec-lang-active', btn.dataset.ensecLangBtn === lang);
      btn.setAttribute('aria-pressed', btn.dataset.ensecLangBtn === lang ? 'true' : 'false');
    });
  }

  function bindDisclosureToggles() {
    document.querySelectorAll('[data-ensec-manual-lang]').forEach(function (wrap) {
      var btn = wrap.querySelector('.ensec-lang__button');
      var panel = wrap.querySelector('.ensec-lang__list-wrapper');
      if (!btn || !panel || btn.dataset.boundToggle === '1') return;
      btn.dataset.boundToggle = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          document.querySelectorAll('[data-ensec-manual-lang] .ensec-lang__button[aria-expanded="true"]').forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
            var p = b.parentElement.querySelector('.ensec-lang__list-wrapper');
            if (p) p.setAttribute('hidden', '');
          });
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });

    if (!document.body.dataset.ensecDropdownCloser) {
      document.body.dataset.ensecDropdownCloser = '1';
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-ensec-manual-lang]')) return;
        document.querySelectorAll('[data-ensec-manual-lang] .ensec-lang__button[aria-expanded="true"]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = b.parentElement.querySelector('.ensec-lang__list-wrapper');
          if (p) p.setAttribute('hidden', '');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-ensec-manual-lang] .ensec-lang__button[aria-expanded="true"]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = b.parentElement.querySelector('.ensec-lang__list-wrapper');
          if (p) p.setAttribute('hidden', '');
        });
      });
    }
  }

  function buildLocaleUrl(targetLang) {
    var path = window.location.pathname || '/';
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    var stripped = path;
    if (stripped.indexOf('/en/') === 0) stripped = stripped.substring(3);
    else if (stripped === '/en') stripped = '/';
    if (stripped.indexOf('/sv/') === 0) stripped = stripped.substring(3);
    else if (stripped === '/sv') stripped = '/';
    if (!stripped) stripped = '/';
    var newPath;
    if (targetLang === 'en') {
      newPath = stripped === '/' ? '/en' : '/en' + stripped;
    } else {
      newPath = stripped;
    }
    return newPath + search + hash;
  }

  function bindLangButtons() {
    document.querySelectorAll('.ensec-lang__link').forEach(function (link) {
      if (link.dataset.boundTranslate === '1') return;
      var lang = (link.getAttribute('hreflang') || '').toLowerCase();
      if (!lang) {
        var langAttr = link.getAttribute('lang');
        if (langAttr) lang = langAttr.toLowerCase();
      }
      if (!lang) {
        var dv = (link.getAttribute('data-value') || '').toLowerCase();
        if (dv === 'en' || dv === 'sv') lang = dv;
      }
      if (lang !== 'en' && lang !== 'sv') return;
      link.dataset.boundTranslate = '1';
      link.dataset.ensecLangBtn = lang;
      link.classList.remove('ensec-lang__link--pending');
      var pendingTag = link.querySelector('.ensec-lang__pending-tag');
      if (pendingTag) pendingTag.remove();
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      link.style.cursor = 'pointer';
      link.style.opacity = '';
      link.style.filter = '';
      link.style.fontStyle = '';

      if (SHOPIFY_MULTILANG) {
        var targetUrl = buildLocaleUrl(lang);
        link.setAttribute('href', targetUrl);
        var navHandler = function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          var langWrap = link.closest('.ensec-lang');
          var btn = langWrap ? langWrap.querySelector('.ensec-lang__button') : null;
          var panel = link.closest('.ensec-lang__list-wrapper');
          if (btn && panel) {
            btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('hidden', '');
          }
          window.location.href = buildLocaleUrl(lang);
          return false;
        };
        link.addEventListener('click', navHandler, { capture: true });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') navHandler(e);
        }, { capture: true });
        return;
      }

      var handler = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        updateLangTriggers(lang);
        applyLang(lang);

        setTimeout(function () { updateLangTriggers(lang); }, 50);
        setTimeout(function () { updateLangTriggers(lang); }, 300);

        var langWrap = link.closest('.ensec-lang');
        var btn = langWrap ? langWrap.querySelector('.ensec-lang__button') : null;
        var panel = link.closest('.ensec-lang__list-wrapper');
        if (btn && panel) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        }
        return false;
      };
      link.addEventListener('click', handler, { capture: true });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') handler(e);
      }, { capture: true });
    });

    if (!SHOPIFY_MULTILANG) {
      document.querySelectorAll('input[name="locale_code"]').forEach(function (input) {
        if (input.dataset.ensecNeutralized === '1') return;
        input.dataset.ensecNeutralized = '1';
        input.addEventListener('change', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          return false;
        }, { capture: true });
      });
    }
  }

  function init() {
    var lang = getLang();
    setLang(lang);
    applyLang(lang);
    bindLangButtons();
    bindDisclosureToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var debounceTimer;
  function rebind() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      applyLang(getLang());
      bindLangButtons();
      bindDisclosureToggles();
    }, 150);
  }

  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      var changed = false;
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) changed = true;
      });
      if (changed) rebind();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  window.EnsecTranslator = {
    set: applyLang,
    get: getLang,
    dict: DICT,
    translate: translateText
  };
})();
